export const popupActionOptions = [
  { type: "NONE", label: "None" },
  { type: "PRODUCT_DETAIL_SCREEN", label: "Product Detail" },
  { type: "PRODUCT_SEARCH_SCREEN", label: "Product Search" },
  { type: "COLLECTION_DETAIL_SCREEN", label: "Collection" },
];

export const normalizeCollectionCategory = collection => {
  const activeCategory = collection?.categories?.find(item => item?.pivot?.active);
  return activeCategory?.name ? activeCategory.name.toLowerCase() : "";
};

export const normalizePopupActionData = data => {
  const defaultState = {
    selectedAction: null,
    keyword: "",
    product: null,
    collection: null,
  };

  if (!data || !data.type) {
    return defaultState;
  }

  const rawType = data.type === "COLLECTION_SCREEN" ? "COLLECTION_DETAIL_SCREEN" : data.type;
  const body = data.body || {};

  switch (rawType) {
    case "NONE":
      return {
        ...defaultState,
        selectedAction: "NONE",
      };
    case "PRODUCT_DETAIL_SCREEN": {
      const id = body.id || data.payload || null;
      return {
        ...defaultState,
        selectedAction: "PRODUCT_DETAIL_SCREEN",
        product: id ? {
          id,
          display_name: body.display_name || "",
          category: body.category || "",
          SKU: body.SKU || "",
        } : null,
      };
    }
    case "PRODUCT_SEARCH_SCREEN":
      return {
        ...defaultState,
        selectedAction: "PRODUCT_SEARCH_SCREEN",
        keyword: body.keyword || data.payload || "",
      };
    case "COLLECTION_DETAIL_SCREEN": {
      const slug = body.slug || data.payload || "";
      return {
        ...defaultState,
        selectedAction: "COLLECTION_DETAIL_SCREEN",
        collection: slug ? {
          id: body.id || null,
          name: body.name || "",
          slug,
          category: body.category || "",
        } : null,
      };
    }
    default:
      return defaultState;
  }
};

export const buildPopupActionPayload = ({
  selectedAction,
  keyword,
  product,
  collection,
}) => {
  const actionType = selectedAction || "NONE";

  switch (actionType) {
    case "PRODUCT_DETAIL_SCREEN":
      return {
        type: "PRODUCT_DETAIL_SCREEN",
        body: {
          id: `${product.id}`,
        },
      };
    case "PRODUCT_SEARCH_SCREEN":
      return {
        type: "PRODUCT_SEARCH_SCREEN",
        body: {
          keyword: keyword.trim(),
        },
      };
    case "COLLECTION_DETAIL_SCREEN":
      return {
        type: "COLLECTION_DETAIL_SCREEN",
        body: {
          slug: collection.slug,
          category: collection.category,
        },
      };
    default:
      return {
        type: "NONE",
        body: null,
      };
  }
};

export const validatePopupAction = ({
  selectedAction,
  keyword,
  product,
  collection,
}) => {
  if (!selectedAction || selectedAction === "NONE") {
    return {};
  }

  if (selectedAction === "PRODUCT_DETAIL_SCREEN" && !product?.id) {
    return { data: ["Please choose a product."] };
  }

  if (selectedAction === "PRODUCT_SEARCH_SCREEN" && !keyword.trim()) {
    return { action_keyword: ["Keyword is required."] };
  }

  if (selectedAction === "COLLECTION_DETAIL_SCREEN") {
    if (!collection?.slug || !collection?.category) {
      return { data: ["Please choose a collection."] };
    }
  }

  return {};
};
